import { render } from "./HeaderArea.vue?vue&type=template&id=f0b0bbc0"
import script from "./HeaderArea.vue?vue&type=script&lang=js"
export * from "./HeaderArea.vue?vue&type=script&lang=js"

import "./HeaderArea.vue?vue&type=style&index=0&id=f0b0bbc0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__